// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__2U9MB","title":"AfterBackImages_title__2csck","images":"AfterBackImages_images__Hd3ZS"};